export function buildTrainingPayload(data) {
  return {
    name: data.name,
    nationalId: data.nationalId,
    residence: data.residence,
    governorate: data.governorate,
    phoneNumber: data.phoneNumber,
    email: data.email,
    workSource: data.workSource,
    workPostalNumber: data.workPostalNumber,
    workAddress: data.workAddress,
    workPhone: data.workPhone,
    jobTitle: data.jobTitle,
    jobRanking: data.jobRanking,
    workNature: data.workNature,
    workWithStatistics: data.workWithStatistics,
    currentWorkDuration: data.currentWorkDuration,
    academicQualification: data.academicQualification,
    academicSpecialization: data.academicSpecialization,
    qualificationSource: data.qualificationSource,
    qualificationYear: data.qualificationYear,
    otherQualifications: data.otherQualifications,
    lastTrainingPrograms: data.lastTrainingPrograms,
    computerUsageQuality: data.computerUsageQuality,
    spssUsageQuality: data.spssUsageQuality,
    trainerName: data.trainerName,
    trainerJobTitle: data.trainerJobTitle,
    trainerPhone: data.trainerPhone,
    trainerFax: data.trainerFax,
    trainerEmail: data.trainerEmail,
    trainingProgramId: data.trainingProgramId,
    isPublished: true,
    status: 3,
  };
}
